import { useState } from "react";
import { useIntl } from "react-intl";
import { useMediaQuery } from "@wayflyer/flyui";
import { IconArrowLeft24Line, IconArrowRight24Line } from "@wayflyer/flyui-icons/24/line";

import { COMMON_MESSAGES } from "../../../components/common-messages";
import { PAGE_TYPE, useFundingApplicationNavigation } from "../../../hooks/navigation-next";

type UseDocumentNavigationActionsOptions = {
  forType: string;
  onPrimaryAction?: () => void;
};

export const useDocumentNavigationActions = ({ forType, onPrimaryAction }: UseDocumentNavigationActionsOptions) => {
  const intl = useIntl();
  const query = useMediaQuery();
  const isMobile = query("sm").windowLte;
  const navigationContext = useFundingApplicationNavigation({
    currentPage: PAGE_TYPE.DOCUMENTS,
    currentStep: forType,
  });
  const [isPrimarySubmitting, setIsPrimarySubmitting] = useState(false);

  const primaryAction = {
    content: navigationContext.nextButtonLabel,
    icon: IconArrowRight24Line,
    loading: isPrimarySubmitting,
    analyticsId: "document-uploads-next-button",
    onAction: async () => {
      if (!navigationContext.nextPath) {
        throw new Error("document-uploads-next-button: nextPath is not defined");
      }
      setIsPrimarySubmitting(true);
      try {
        await navigationContext.navigateWithStateUpdate(navigationContext.nextPath);
      } finally {
        setIsPrimarySubmitting(false);
      }
      onPrimaryAction?.();
    },
  };

  const secondaryAction = {
    content: isMobile ? undefined : intl.formatMessage(COMMON_MESSAGES.backLabel),
    icon: isMobile ? IconArrowLeft24Line : undefined,
    analyticsId: "document-uploads-back-button",
    onAction: () => {
      if (navigationContext.previousPath) {
        navigationContext.navigate(navigationContext.previousPath);
      }
    },
  };

  return { primaryAction, secondaryAction };
};
